export const initialState = () => ({
    processing: false,
    showForm: false,
    credentialTypeName: null,
    credentialTypes: [],
    credential: null,
});

export const state = initialState();
